<template>
	<v-app
		id="inspire"
		:class="[
			{
				'schedule-layout': true,
				'box-layout': boxLayout,
				'rtl-layout': rtlLayout,
			},
		]"
	>
		<div class="app-default-layout">
			<template v-if="!canRender">
				<socket size="112px"></socket>
			</template>
			<template v-if="canRender">
				<!-- App Left Sidebar -->
				<div class="app-sidebar-container">
					<NavSidebarHOC />
				</div>
				<!-- App Main Content -->
				<div class="app-content" @click="onBodyClicked">
					<!-- App Router -->
					<transition name="router-anim" :enter-active-class="`animated ${selectedRouterAnimation}`">
						<router-view></router-view>
					</transition>
				</div>
			</template>
			<!-- Refresh Access / Delete Account -->
			<renew-token :user="user" />
			<AppConfirmationDialog />
		</div>
	</v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { connectToSocket } from "@/api/socketAPI"; // NOTE: this should get moved to main.js once schedule goes live
import NavSidebarHOC from "@/components/Sidebar/NavSidebarHOC";
import RenewToken from "@/components/RenewToken";
import AppConfirmationDialog from "@/components/AppConfirmationDialog";
import NavSidebarToggleState from "@/constants/NavSidebarToggleState";

export default {
	name: "schedule",
	components: {
		NavSidebarHOC,
		RenewToken,
		AppConfirmationDialog,
	},
	data() {
		return {
			canRender: false,
		};
	},
	computed: {
		...mapGetters( [ "boxLayout", "rtlLayout", "selectedRouterAnimation", ] ),
		...mapGetters( "auth", [ "user", ] ),
	},
	methods: {
		...mapActions( [ "loadTeams", ] ),
		...mapActions( "sidebar", [ "toggleSidebar", ] ),
		tryRedirect() {
			if ( !this.user?.personId ) {
				return;
			}
			const { $route, } = this;
			if ( !this.user.isLegacyMeetingUser && $route.name.startsWith( "schedule" ) ) {
				return window.location.assign( "/t2/one-on-ones" );
			}
			this.canRender = true;
		},
		onBodyClicked() {
			this.toggleSidebar( { toggleState: NavSidebarToggleState.CLOSED, } );
		},
	},
	watch: {
		user() {
			this.tryRedirect();
		},
	},
	created() {
		this.tryRedirect();
	},
	mounted() {
		this.tryRedirect();
		// NOTE: this does not have to be *the* long term spot which we connect to the new websockets endpoint
		// My assumption was this would work for proving it out, and we can move to a better location as one emerges
		connectToSocket();
		this.loadTeams();
	},
};
</script>

<style lang="scss" scoped>
.app-default-layout {
	height: 100vh;
}

.app-content {
	position: absolute;
	overflow: hidden;
	// leave room for sidebar
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;

	@include for-size('sm') {
		left: $nav-sidebar-tablet-width;
	}

	@include for-size('lg') {
		// leave room for sidebar
		left: $nav-sidebar-width;
	}
}

.app-sidebar-container {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: 0;
	background-color: $mono-000;
	z-index: 100;

	@include for-size('sm') {
		width: $nav-sidebar-tablet-width;
		display: block;
	}

	@include for-size('lg') {
		width: $nav-sidebar-width;
	}
}
</style>



// WEBPACK FOOTER //
// src/layouts/schedule.vue